import ParamHelper from "../helpers/param.helper";
import TypeHelper from "../helpers/type.helper";
import { merge } from "../utils";
var AnimationBuilder = /** @class */ (function () {
    function AnimationBuilder(name, defaultOptions) {
        if (name !== undefined && !ParamHelper.isString(name)) {
            throw new TypeError("[" + AnimationBuilder.NAMESPACE + "] Animation name isn't a valid string: \"" + name + "\"");
        }
        if (defaultOptions !== undefined && !TypeHelper.isAnimationDescriptor(defaultOptions)) {
            throw new TypeError("[" + AnimationBuilder.NAMESPACE + "] Animation default options aren't a valid object.\"");
        }
        if (defaultOptions && defaultOptions.name) {
            throw new Error("[" + AnimationBuilder.NAMESPACE + "] It's not possible to set a default \"name\".");
        }
        if (defaultOptions && defaultOptions.label) {
            throw new Error("[" + AnimationBuilder.NAMESPACE + "] It's not possible to set a default \"label\".");
        }
        this.descriptor = merge({
            name: name,
            duration: 1,
            position: "+=0",
            repeat: 0,
            yoyo: false,
            delay: 0,
            ease: "power1.out",
            momentum: 0,
            transformOrigin: "center center",
            from: {},
            to: {},
        }, defaultOptions);
    }
    AnimationBuilder.prototype.duration = function (value) {
        if (value !== undefined) {
            if (ParamHelper.isNumber(value)) {
                this.descriptor.duration = ParamHelper.toFloat(value);
            }
            else {
                throw new TypeError("[" + AnimationBuilder.NAMESPACE + "] Value for \"duration\" isn't a valid number: \"" + value + "\"");
            }
        }
        return this;
    };
    AnimationBuilder.prototype.position = function (value) {
        if (value !== undefined) {
            if (ParamHelper.isString(value)) {
                this.descriptor.position = ParamHelper.toString(value);
            }
            else {
                throw new TypeError("[" + AnimationBuilder.NAMESPACE + "] Value for \"position\" isn't a valid string: \"" + value + "\"");
            }
        }
        return this;
    };
    AnimationBuilder.prototype.repeat = function (value) {
        if (value !== undefined) {
            if (ParamHelper.isNumber(value)) {
                this.descriptor.repeat = ParamHelper.toInteger(value);
            }
            else {
                throw new TypeError("[" + AnimationBuilder.NAMESPACE + "] Value for \"repeat\" isn't a valid number: \"" + value + "\"");
            }
        }
        return this;
    };
    AnimationBuilder.prototype.yoyo = function (value) {
        if (value !== undefined) {
            if (ParamHelper.isBoolean(value)) {
                this.descriptor.yoyo = ParamHelper.toBoolean(value);
            }
            else {
                throw new TypeError("[" + AnimationBuilder.NAMESPACE + "] Value for \"yoyo\" isn't a valid boolean: \"" + value + "\"");
            }
        }
        return this;
    };
    AnimationBuilder.prototype.delay = function (value) {
        if (value !== undefined) {
            if (ParamHelper.isNumber(value)) {
                this.descriptor.delay = ParamHelper.toFloat(value);
            }
            else {
                throw new TypeError("[" + AnimationBuilder.NAMESPACE + "] Value for \"delay\" isn't a valid number: \"" + value + "\"");
            }
        }
        return this;
    };
    AnimationBuilder.prototype.momentum = function (value) {
        if (value !== undefined) {
            if (ParamHelper.isNumber(value)) {
                this.descriptor.momentum = ParamHelper.toFloat(value);
            }
            else {
                throw new TypeError("[" + AnimationBuilder.NAMESPACE + "] Value for \"momentum\" isn't a valid number: \"" + value + "\"");
            }
        }
        return this;
    };
    AnimationBuilder.prototype.stagger = function (value) {
        if (value !== undefined) {
            if (ParamHelper.isNumber(value)) {
                this.descriptor.stagger = ParamHelper.toFloat(value);
            }
            else {
                throw new TypeError("[" + AnimationBuilder.NAMESPACE + "] Value for \"stagger\" isn't a valid number: \"" + value + "\"");
            }
        }
        return this;
    };
    AnimationBuilder.prototype.transformOrigin = function (value) {
        if (value !== undefined) {
            if (ParamHelper.isString(value)) {
                this.descriptor.transformOrigin = ParamHelper.toString(value);
            }
            else {
                throw new TypeError("[" + AnimationBuilder.NAMESPACE + "] Value for \"transformOrigin\" isn't a valid string: \"" + value + "\"");
            }
        }
        return this;
    };
    AnimationBuilder.prototype.ease = function (value) {
        if (value !== undefined) {
            if (ParamHelper.isString(value)) {
                this.descriptor.ease = ParamHelper.toString(value);
            }
            else {
                throw new TypeError("[" + AnimationBuilder.NAMESPACE + "] Value for \"ease\" isn't a valid string: \"" + value + "\"");
            }
        }
        return this;
    };
    AnimationBuilder.prototype.label = function (value) {
        if (value !== undefined) {
            if (ParamHelper.isString(value)) {
                this.descriptor.label = ParamHelper.toString(value);
            }
            else {
                throw new TypeError("[" + AnimationBuilder.NAMESPACE + "] Value for \"label\" isn't a valid string: \"" + value + "\"");
            }
        }
        return this;
    };
    AnimationBuilder.prototype.fromAlpha = function (value) {
        if (value !== undefined) {
            if (ParamHelper.isNumber(value)) {
                this.descriptor.from.alpha = ParamHelper.toFloat(value);
            }
            else {
                throw new TypeError("[" + AnimationBuilder.NAMESPACE + "] Value for \"fromAlpha\" isn't a valid number: \"" + value + "\"");
            }
        }
        return this;
    };
    AnimationBuilder.prototype.toAlpha = function (value) {
        if (value !== undefined) {
            if (ParamHelper.isNumber(value)) {
                this.descriptor.to.alpha = ParamHelper.toFloat(value);
            }
            else {
                throw new TypeError("[" + AnimationBuilder.NAMESPACE + "] Value for \"toAlpha\" isn't a valid number: \"" + value + "\"");
            }
        }
        return this;
    };
    AnimationBuilder.prototype.fromX = function (value) {
        if (value !== undefined) {
            if (ParamHelper.isNumber(value)) {
                this.descriptor.from.x = ParamHelper.toInteger(value);
            }
            else {
                throw new TypeError("[" + AnimationBuilder.NAMESPACE + "] Value for \"fromX\" isn't a valid number: \"" + value + "\"");
            }
        }
        return this;
    };
    AnimationBuilder.prototype.toX = function (value) {
        if (value !== undefined) {
            if (ParamHelper.isNumber(value)) {
                this.descriptor.to.x = ParamHelper.toInteger(value);
            }
            else {
                throw new TypeError("[" + AnimationBuilder.NAMESPACE + "] Value for \"toX\" isn't a valid number: \"" + value + "\"");
            }
        }
        return this;
    };
    AnimationBuilder.prototype.fromY = function (value) {
        if (value !== undefined) {
            if (ParamHelper.isNumber(value)) {
                this.descriptor.from.y = ParamHelper.toInteger(value);
            }
            else {
                throw new TypeError("[" + AnimationBuilder.NAMESPACE + "] Value for \"fromY\" isn't a valid number: \"" + value + "\"");
            }
        }
        return this;
    };
    AnimationBuilder.prototype.toY = function (value) {
        if (value !== undefined) {
            if (ParamHelper.isNumber(value)) {
                this.descriptor.to.y = ParamHelper.toInteger(value);
            }
            else {
                throw new TypeError("[" + AnimationBuilder.NAMESPACE + "] Value for \"toY\" isn't a valid number: \"" + value + "\"");
            }
        }
        return this;
    };
    AnimationBuilder.prototype.fromXPercent = function (value) {
        if (value !== undefined) {
            if (ParamHelper.isNumber(value)) {
                this.descriptor.from.xPercent = ParamHelper.toFloat(value);
            }
            else {
                throw new TypeError("[" + AnimationBuilder.NAMESPACE + "] Value for \"fromXPercent\" isn't a valid number: \"" + value + "\"");
            }
        }
        return this;
    };
    AnimationBuilder.prototype.toXPercent = function (value) {
        if (value !== undefined) {
            if (ParamHelper.isNumber(value)) {
                this.descriptor.to.xPercent = ParamHelper.toFloat(value);
            }
            else {
                throw new TypeError("[" + AnimationBuilder.NAMESPACE + "] Value for \"toXPercent\" isn't a valid number: \"" + value + "\"");
            }
        }
        return this;
    };
    AnimationBuilder.prototype.fromYPercent = function (value) {
        if (value !== undefined) {
            if (ParamHelper.isNumber(value)) {
                this.descriptor.from.yPercent = ParamHelper.toFloat(value);
            }
            else {
                throw new TypeError("[" + AnimationBuilder.NAMESPACE + "] Value for \"fromYPercent\" isn't a valid number: \"" + value + "\"");
            }
        }
        return this;
    };
    AnimationBuilder.prototype.toYPercent = function (value) {
        if (value !== undefined) {
            if (ParamHelper.isNumber(value)) {
                this.descriptor.to.yPercent = ParamHelper.toFloat(value);
            }
            else {
                throw new TypeError("[" + AnimationBuilder.NAMESPACE + "] Value for \"toYPercent\" isn't a valid number: \"" + value + "\"");
            }
        }
        return this;
    };
    AnimationBuilder.prototype.fromScale = function (value) {
        if (value !== undefined) {
            if (ParamHelper.isNumber(value)) {
                this.descriptor.from.scale = ParamHelper.toFloat(value);
            }
            else {
                throw new TypeError("[" + AnimationBuilder.NAMESPACE + "] Value for \"fromScale\" isn't a valid number: \"" + value + "\"");
            }
        }
        return this;
    };
    AnimationBuilder.prototype.toScale = function (value) {
        if (value !== undefined) {
            if (ParamHelper.isNumber(value)) {
                this.descriptor.to.scale = ParamHelper.toFloat(value);
            }
            else {
                throw new TypeError("[" + AnimationBuilder.NAMESPACE + "] Value for \"toScale\" isn't a valid number: \"" + value + "\"");
            }
        }
        return this;
    };
    AnimationBuilder.prototype.fromRotation = function (value) {
        if (value !== undefined) {
            if (ParamHelper.isNumber(value)) {
                this.descriptor.from.rotation = ParamHelper.toFloat(value);
            }
            else {
                throw new TypeError("[" + AnimationBuilder.NAMESPACE + "] Value for \"fromRotation\" isn't a valid number: \"" + value + "\"");
            }
        }
        return this;
    };
    AnimationBuilder.prototype.toRotation = function (value) {
        if (value !== undefined) {
            if (ParamHelper.isNumber(value)) {
                this.descriptor.to.rotation = ParamHelper.toFloat(value);
            }
            else {
                throw new TypeError("[" + AnimationBuilder.NAMESPACE + "] Value for \"toRotation\" isn't a valid number: \"" + value + "\"");
            }
        }
        return this;
    };
    AnimationBuilder.prototype.fromWidth = function (value) {
        if (value !== undefined) {
            if (ParamHelper.isNumber(value)) {
                this.descriptor.from.width = ParamHelper.toInteger(value);
            }
            else {
                throw new TypeError("[" + AnimationBuilder.NAMESPACE + "] Value for \"fromWidth\" isn't a valid number: \"" + value + "\"");
            }
        }
        return this;
    };
    AnimationBuilder.prototype.toWidth = function (value) {
        if (value !== undefined) {
            if (ParamHelper.isNumber(value)) {
                this.descriptor.to.width = ParamHelper.toInteger(value);
            }
            else {
                throw new TypeError("[" + AnimationBuilder.NAMESPACE + "] Value for \"toWidth\" isn't a valid number: \"" + value + "\"");
            }
        }
        return this;
    };
    AnimationBuilder.prototype.build = function () {
        return this.descriptor;
    };
    AnimationBuilder.NAMESPACE = "AnimationBuilder";
    return AnimationBuilder;
}());
export default AnimationBuilder;
//# sourceMappingURL=animation.builder.js.map